import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PublicLayout from './common/PublicLayout';
import RenewalDetails from './renewal/RenewalDetails';
import RenewalMembership from './renewal/RenewalMembership';
import RenewalPayment from './renewal/RenewalPayment';
import RenewalReview from './renewal/RenewalReview';
import RenewalThankYou from './renewal/RenewalThankYou';

function Renewal() {
  return (
    <PublicLayout>
      <Routes>
        <Route index element={<RenewalDetails />} />
        <Route path="type" element={<RenewalMembership />} />
        <Route path="payment" element={<RenewalPayment />} />
        <Route path="review" element={<RenewalReview />} />
        <Route path="thank-you" element={<RenewalThankYou />} />
        <Route path="*" element={<Navigate to="/renewal" replace />} />
      </Routes>
    </PublicLayout>
  );
}

export default Renewal;
